
import React, { Component } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Fragment } from 'react';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import flecha from '../../../../../../assets/img/icons/down arrow.png';
import {standardActions, customStandardActions2 } from "../../../Utils/Grid/StandardActions";
import iconoFacturar from '../../../../../../assets/img/icons/facturar.png';
import AnularFacturaForm from './anularFacturaForm';

import {api} from 'api';


export default class GridDespachoInterno extends Component {

    state = {
        detalles: {
            results: [],
            count: 0
        },
    }

    componentDidMount() {
        const { detalles } = this.props;
        this.setState({
            detalles: {
                results: detalles.length > 0 ? detalles : [],
                count: detalles.length > 0 ? detalles.length : 0,
            }
        });
    }

    adicionalbotonimprimible = (id, row) => {
        // if (row.estado) {
        //     return (<div></div>)
        // }
        return (
            <a className="px-2" style={{cursor: "pointer", color: "#c4183c"}}
                onClick={(e)=>{
                    e.preventDefault();
                    this.props.PDFITINERARIO(row.despacho_interno.id)
                    console.log(row.despacho_interno)
                }}
            >
                <img
                    className="action-img"
                    title="Imprimible"
                    src={require("../../../../../../assets/img/icons/Ver.png")} alt="Ver eliminado"/>
            </a>
        )

    }

    generatePDFBotton = (id, row) => {
        return (
            <a
                className="px-2"
                // style={{cursor: "pointer", color: "#c4183c"}}
                onClick={(e)=>{
                    e.preventDefault();
                    this.props.generarPDFFactura(row.despacho.id)
                }}>
                <img
                    className="action-img"
                    title="GENERAR PDF"
                    src={require("../../../../../../assets/img/icons/facturapdf.png")} alt="PDF Factura" />
            </a>
        )
    }

    render() {
        const { loader, open_modal_anular_factura, open_modal_historial, permisos, page, onPageChange, onSortChange, estado } = this.props;
        const { detalles } = this.state;

        return (
            <div className="row m-none">
                <div className="col-12">
                    <Fragment>
                        <Grid hover
                            pagination={false}
                            striped data={detalles}
                            loading={loader}
                        >
                            <TableHeaderColumn
                                dataField="id"
                                dataAlign="center"
                                isKey
                                dataSort
                                width="10%"
                                /* dataFormat={
                                    standardActions({ adicional: this.adicionalbotonimprimible})
                                } */
                                dataFormat={(cell, row, index) => {
                                    return customStandardActions2(cell, row,{
                                        generatePDFDTE: estado && row.despacho_interno.facturas_despacho.length > 0 ? this.generatePDFBotton : undefined,
                                        adicional2: estado ? this.adicionalbotonimprimible : undefined,
                                    });
                                }}
                            >
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="despacho_interno"
                                dataSort
                                dataFormat={
                                    (cell, row) => (cell ? cell.no_despacho : '--')
                                }
                            >
                                DESPACHO
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="despacho_interno"
                                dataSort
                                dataFormat={
                                    (cell, row) => (cell && cell.bodega_origen ? cell.bodega_origen.nombre : '--')
                                }
                            >
                                ORIGEN
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="despacho_interno"
                                dataSort
                                dataFormat={
                                    (cell, row) => (cell && cell.bodega_destino ? cell.bodega_destino.nombre : '--')
                                }
                            >
                                DESTINO
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="firma"
                                dataSort
                                dataFormat={
                                    (cell, row) => (
                                        cell ? (
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img className="firma-img" src={cell}  />
                                            </div>
                                        ) : 'Sin entregar'
                                    )
                                }
                            >
                                FIRMA DE RECIBIDO
                            </TableHeaderColumn>
                        </Grid>
                    </Fragment>
                </div>
            </div>
        )
    }
}
